export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  featured: boolean;
  content: string[];
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  image: string;
  articleCount: number;
}

export interface RecommendedItem {
  slug: string;
  name: string;
  description: string;
  price: string;
  image: string;
  category: string;
  rating: number;
}

export const categories: Category[] = [
  {
    slug: 'fashion',
    name: '少女穿搭',
    description: '探索最in的少女风格穿搭灵感，从甜美到酷飒，找到属于你的专属风格',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20kawaii%20fashion%20style%20young%20girls%20wearing%20pastel%20color%20dresses%20and%20skirts%20in%20cherry%20blossom%20park%2C%20soft%20dreamy%20lighting%2C%20fashion%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20warm%20tone%2C%20elegant%20aesthetic&width=800&height=600&seq=cat-fashion-01&orientation=landscape',
    articleCount: 128
  },
  {
    slug: 'beauty',
    name: '少女美妆',
    description: '从零开始的少女美妆教程，日常妆、约会妆、派对妆轻松掌握',
    icon: 'ri-palette-line',
    image: 'https://readdy.ai/api/search-image?query=soft%20pink%20makeup%20products%20on%20vanity%20table%20with%20flowers%2C%20cute%20cosmetics%20arrangement%2C%20pastel%20color%20palette%2C%20natural%20daylight%2C%20beauty%20photography%2C%20clean%20aesthetic%20composition%2C%20feminine%20style&width=800&height=600&seq=cat-beauty-02&orientation=landscape',
    articleCount: 96
  },
  {
    slug: 'lifestyle',
    name: '少女生活',
    description: '手账、烘焙、手作、房间布置……发现让生活更美好的少女心生活方式',
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=cozy%20room%20interior%20with%20fairy%20lights%20and%20plush%20toys%2C%20cute%20stationery%20and%20journal%20on%20desk%2C%20warm%20sunlight%20through%20window%2C%20soft%20pastel%20decor%2C%20lifestyle%20photography%2C%20dreamy%20atmosphere%2C%20feminine%20aesthetic&width=800&height=600&seq=cat-lifestyle-03&orientation=landscape',
    articleCount: 85
  },
  {
    slug: 'community',
    name: '少女社群',
    description: '加入少女兴趣社群，结识志同道合的闺蜜，一起分享快乐与成长',
    icon: 'ri-group-line',
    image: 'https://readdy.ai/api/search-image?query=group%20of%20young%20girls%20friends%20having%20fun%20together%20in%20cafe%2C%20laughing%20and%20sharing%20stories%2C%20warm%20atmosphere%2C%20candid%20photography%2C%20soft%20natural%20lighting%2C%20joyful%20vibe%2C%20pastel%20color%20tones&width=800&height=600&seq=cat-community-04&orientation=landscape',
    articleCount: 62
  }
];

export const articles: Article[] = [
  {
    slug: 'spring-pastel-outfit-guide',
    title: '2026春季少女穿搭指南：马卡龙色系这样搭最甜美',
    excerpt: '春天来了，是时候把衣柜换成温柔的粉色、薄荷绿和奶油黄了！本期为大家整理了今年春季最受欢迎的少女风格穿搭灵感，从日常通勤到周末约会，让你每天都美美哒~',
    category: '少女穿搭',
    categorySlug: 'fashion',
    coverImage: 'https://readdy.ai/api/search-image?query=young%20asian%20girl%20wearing%20pastel%20pink%20dress%20with%20lace%20details%20standing%20in%20cherry%20blossom%20garden%2C%20soft%20spring%20sunlight%2C%20dreamy%20fashion%20editorial%20photography%2C%20elegant%20feminine%20style%2C%20clean%20composition&width=800&height=500&seq=article-fashion-01&orientation=landscape',
    author: '樱花酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-sakura&orientation=squarish',
    publishDate: '2026-03-15',
    readTime: '8分钟',
    tags: ['春季穿搭', '马卡龙色系', '少女风格', '日常搭配'],
    featured: true,
    content: [
      '春天是一个充满希望和温柔的季节，而在少女风格的穿搭中，马卡龙色系无疑是最能代表春日气息的选择。粉色、薄荷绿、奶油黄、淡紫……这些柔和甜美的色彩，就像春天的花朵一样，让人心情愉悦。',
      '马卡龙色系的魅力在于它的包容性，无论你是走甜美路线还是想要一点小清新的感觉，都能在这个色系中找到适合自己的搭配方案。',
      '首先来看看粉色系搭配。粉色是少女风格中最经典的颜色，但不同深浅的粉色会呈现出完全不同的感觉。浅粉色连衣裙搭配白色帆布鞋，清新自然；而玫瑰粉色针织衫配白色阔腿裤，则显得温柔知性。',
      '薄荷绿是今年春季的流行色之一，它清新又不失甜美。一件薄荷绿的衬衫裙，搭配一双米色玛丽珍鞋，整个人就像从画报中走出来的少女。如果想要更有层次感，可以在外面叠穿一件白色针织开衫。',
      '奶油黄是最显白的颜色之一，特别适合亚洲女生的肤色。奶油黄的针织上衣搭配高腰牛仔裤，简单却不失精致。如果想要更加甜美，可以选择奶油黄的碎花裙，搭配一双粉色芭蕾鞋。',
      '淡紫色是今年秀场上频繁出现的颜色，它比粉色更多了一份神秘感。淡紫色的雪纺衬衫搭配白色百褶裙，仙气十足；淡紫色的西装外套搭配同色系连衣裙，则展现出不一样的干练少女感。',
      '搭配小贴士：马卡龙色系搭配时，全身上下最好不要超过三个颜色。如果上衣是比较抢眼的颜色，下装就选择白色或者米色来平衡；配饰方面，珍珠发夹和蝴蝶结发带都是少女风格的加分项。'
    ]
  },
  {
    slug: 'daily-natural-makeup-tutorial',
    title: '零基础也能学会！五分钟日常少女妆教程',
    excerpt: '不会化妆的少女们看过来！超简单的日常妆容教程，只要五步就能拥有自然好气色，上课上班约会都适用，手残党也能轻松掌握~',
    category: '少女美妆',
    categorySlug: 'beauty',
    coverImage: 'https://readdy.ai/api/search-image?query=young%20girl%20applying%20soft%20pink%20makeup%20in%20front%20of%20mirror%20with%20natural%20daylight%2C%20cute%20cosmetics%20on%20vanity%2C%20fresh%20dewy%20skin%2C%20beauty%20tutorial%20photography%2C%20soft%20feminine%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=article-beauty-01&orientation=landscape',
    author: '蜜桃酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20peach%20color%20hair%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-momo&orientation=squarish',
    publishDate: '2026-03-12',
    readTime: '6分钟',
    tags: ['日常妆容', '化妆教程', '少女美妆', '新手化妆'],
    featured: true,
    content: [
      '很多少女都觉得化妆是一件很复杂的事情，但其实日常妆容只需要抓住几个关键步骤，就能轻松打造出自然好气色。今天就来教大家一个五分钟就能搞定的日常少女妆~',
      '第一步：做好妆前保湿。无论化什么妆，妆前保湿都是最重要的一步。选择一款清爽的保湿乳液，轻轻按摩至吸收，让皮肤喝饱水，这样后续的底妆才会更加服帖自然。',
      '第二步：轻薄底妆。日常妆容不需要厚重的遮瑕，选择一款质地轻薄的BB霜或者气垫粉底，用美妆蛋轻轻拍开。记住要少量多次，从面部中央向外推开，这样妆感会更加自然。',
      '第三步：眉毛自然填充。用眉笔顺着眉毛生长的方向轻轻填充，不需要画出很明显的眉形，保持自然的毛流感就好。选择比自己发色浅一号的眉笔颜色会更加柔和。',
      '第四步：粉色系腮红和眼影。少女妆容的精髓在于好气色！选择一款粉嫩的腮红，微笑时在苹果肌上轻轻扫过。眼影选择大地色或者粉色系，用浅色打底，再用深一点的颜色在眼尾晕染即可。',
      '第五步：水润唇妆。选择一款滋润型的唇釉或者唇膏，颜色以粉色、珊瑚色或者豆沙色为主。涂之前可以先涂一层润唇膏打底，这样唇妆会更加水润自然。',
      '小贴士：日常妆容的重点是"提气色"而不是"变脸"，所以不要追求过度的遮瑕和修容，保持皮肤的自然质感才是最少女的妆容哦！'
    ]
  },
  {
    slug: 'cute-room-decor-ideas',
    title: '少女心爆棚！打造梦幻房间的10个布置灵感',
    excerpt: '想要拥有一个像童话一样的梦幻房间吗？从灯光、床品到小装饰，这10个少女房间布置灵感让你的小窝瞬间变身高颜值打卡地~',
    category: '少女生活',
    categorySlug: 'lifestyle',
    coverImage: 'https://readdy.ai/api/search-image?query=dreamy%20bedroom%20interior%20with%20fairy%20lights%20and%20pink%20bedding%2C%20cute%20plush%20toys%20on%20bed%2C%20polaroid%20photos%20on%20wall%2C%20warm%20cozy%20atmosphere%2C%20soft%20natural%20lighting%2C%20feminine%20room%20decor%2C%20clean%20aesthetic&width=800&height=500&seq=article-lifestyle-01&orientation=landscape',
    author: '草莓酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20red%20hair%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-berry&orientation=squarish',
    publishDate: '2026-03-10',
    readTime: '10分钟',
    tags: ['房间布置', '少女心', '家居装饰', '生活美学'],
    featured: true,
    content: [
      '每次在社交媒体上看到那些超级梦幻的少女房间，是不是都超级羡慕？其实打造一个少女心爆棚的房间并不难，只需要一些小心思和小物件，你的小窝就能焕然一新！',
      '第一个灵感：星星灯串。这是打造梦幻氛围的必备单品！将暖黄色的星星灯串挂在床头或者窗帘上，晚上打开时整个房间都变得温柔又浪漫。推荐选择电池款的，这样不受插座位置限制。',
      '第二个灵感：粉色系床品。床是房间里最大的视觉焦点，选择一套粉色、奶油色或者碎花图案的床品，瞬间让整个房间的少女感翻倍。材质方面推荐纯棉或者天丝，舒适又好看。',
      '第三个灵感：照片墙。打印一些自己喜欢的照片、明信片或者插画卡片，用彩色夹子或者麻绳挂在墙上，打造属于你的专属回忆墙。也可以加一些拍立得照片，更有复古少女的感觉。',
      '第四个灵感：毛绒玩偶角。在床头或者飘窗上放几个可爱的毛绒玩偶，不仅是装饰，晚上抱着睡觉也很治愈。推荐选择一些经典的卡通形象或者可爱的动物造型。',
      '第五个灵感：香薰蜡烛。选择一个颜值高的香薰蜡烛，放在床头柜上，睡前点燃一会儿，淡淡的香气让整个房间都充满了仪式感。少女们可以选择花果香调，比如玫瑰、樱花或者蜜桃。',
      '第六个灵感：小推车收纳。宜家那种三层小推车超级实用，可以放护肤品、文具、零食等杂物，既美观又整洁。可以在每层铺上好看的垫布，更加精致。',
      '第七个灵感：全身镜。一面好看的全身镜不仅是穿搭必备，也能让房间显得更加宽敞明亮。选择有边框设计的款式，金色或者白色的边框都很适合少女风格。'
    ]
  },
  {
    slug: 'summer-skincare-routine',
    title: '夏日少女护肤全攻略：清爽保湿不黏腻',
    excerpt: '夏天护肤最大的困扰就是油腻和闷痘！这份少女专属的夏日护肤流程，从洁面到防晒，让你的皮肤清爽水润一整个夏天~',
    category: '少女美妆',
    categorySlug: 'beauty',
    coverImage: 'https://readdy.ai/api/search-image?query=young%20girl%20with%20fresh%20clean%20skin%20applying%20skincare%20products%2C%20summer%20vibes%2C%20natural%20glowing%20complexion%2C%20dewy%20skin%20texture%2C%20beauty%20photography%2C%20soft%20sunlight%2C%20feminine%20aesthetic&width=800&height=500&seq=article-beauty-02&orientation=landscape',
    author: '蜜桃酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20peach%20color%20hair%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-momo&orientation=squarish',
    publishDate: '2026-03-08',
    readTime: '7分钟',
    tags: ['护肤', '夏日护肤', '少女护肤', '清爽保湿'],
    featured: false,
    content: [
      '夏天对少女们的皮肤来说是一个考验，高温出汗加上紫外线，很容易出现出油、毛孔粗大、长痘痘等问题。但其实只要掌握正确的护肤流程，夏天也能拥有清爽水润的好皮肤~',
      '首先是洁面，夏天建议早晚各洗一次脸。早上用温和的氨基酸洁面，晚上如果涂了防晒或者化了妆，需要先用卸妆产品再用洁面。不要因为出油就频繁洗脸或者用强力洁面产品，这样反而会破坏皮肤屏障。',
      '然后是爽肤水，夏天可以选择质地清爽的爽肤水，用化妆棉轻轻擦拭，可以帮助二次清洁和补水。推荐含有金缕梅、茶树等成分的爽肤水，有一定的控油效果。',
      '精华液方面，夏天建议选择质地轻薄的精华，比如含有烟酰胺或者玻尿酸成分的精华，能够美白提亮同时补水保湿。油性皮肤的少女可以选择含有水杨酸的精华，帮助疏通毛孔。'
    ]
  },
  {
    slug: 'handmade-journal-guide',
    title: '手账入门指南：记录属于你的少女日常',
    excerpt: '手账不只是记录，更是一种治愈的生活方式。从选本子、挑笔到排版技巧，这篇手账入门指南带你开启美好的记录之旅~',
    category: '少女生活',
    categorySlug: 'lifestyle',
    coverImage: 'https://readdy.ai/api/search-image?query=cute%20stationery%20flat%20lay%20with%20colorful%20washi%20tapes%20and%20stickers%20on%20desk%2C%20handmade%20journal%20with%20pretty%20handwriting%2C%20pastel%20color%20pens%2C%20creative%20scrapbooking%2C%20warm%20lighting%2C%20feminine%20aesthetic&width=800&height=500&seq=article-lifestyle-02&orientation=landscape',
    author: '草莓酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20red%20hair%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-berry&orientation=squarish',
    publishDate: '2026-03-05',
    readTime: '9分钟',
    tags: ['手账', '文具', '生活记录', '少女日常'],
    featured: false,
    content: [
      '手账是近年来非常流行的一种生活方式，它不仅仅是记录日常，更是一种自我表达和治愈的方式。对于少女们来说，一本漂亮的手账就像是一个属于自己的小世界。',
      '入门第一步：选择一本适合的手账本。新手推荐A6或者B6尺寸，不大不小刚刚好。内页可以选择方格或者点阵的，这样既方便写字，也方便画简单的图案和排版。封面选择自己喜欢的颜色和图案就好~'
    ]
  },
  {
    slug: 'girls-social-media-photo-tips',
    title: '少女感拍照秘籍：教你拍出朋友圈高赞照片',
    excerpt: '每次发朋友圈都不知道怎么拍才好看？学会这些少女感拍照技巧，从构图、姿势到滤镜，让你每一张照片都美得像画报~',
    category: '少女生活',
    categorySlug: 'lifestyle',
    coverImage: 'https://readdy.ai/api/search-image?query=young%20girl%20taking%20selfie%20with%20phone%20in%20cafe%2C%20natural%20window%20light%2C%20cute%20outfit%2C%20soft%20pink%20background%2C%20lifestyle%20photography%2C%20feminine%20style%2C%20warm%20tone%2C%20clean%20composition&width=800&height=500&seq=article-lifestyle-03&orientation=landscape',
    author: '樱花酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-sakura&orientation=squarish',
    publishDate: '2026-03-03',
    readTime: '7分钟',
    tags: ['拍照技巧', '少女感', '朋友圈', '摄影'],
    featured: false,
    content: [
      '是不是每次看到别人的朋友圈照片都超级好看，自己拍出来却总觉得差了点什么？今天就来分享一些少女感拍照的小技巧，让你也能拍出美美的照片！',
      '光线是拍照的灵魂！尽量选择自然光拍摄，窗边是最佳位置。让光线从侧面或者前方打在脸上，可以显得皮肤更加白皙通透。避免顶光和逆光，容易显得脸黑或者五官不清晰。'
    ]
  },
  {
    slug: 'korean-style-outfit-2026',
    title: '韩系少女风穿搭：2026年最火的5种风格解析',
    excerpt: '韩系穿搭一直是少女们的最爱！今年韩系少女风格又有了新的变化，从学院风到街头感，总有一款适合你~',
    category: '少女穿搭',
    categorySlug: 'fashion',
    coverImage: 'https://readdy.ai/api/search-image?query=young%20korean%20style%20girl%20wearing%20trendy%20oversized%20blazer%20and%20pleated%20skirt%20on%20city%20street%2C%20fashion%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20minimal%20style%2C%20clean%20composition&width=800&height=500&seq=article-fashion-02&orientation=landscape',
    author: '樱花酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-sakura&orientation=squarish',
    publishDate: '2026-02-28',
    readTime: '8分钟',
    tags: ['韩系穿搭', '少女风格', '流行趋势', '日常搭配'],
    featured: true,
    content: [
      '韩系穿搭一直在少女群体中有着超高的人气，每年都会有新的流行趋势出现。2026年的韩系少女风格更加多元化，从甜美到酷飒，每个人都能找到适合自己的风格。',
      '第一种：温柔学院风。这是韩系少女穿搭中最经典也最不会出错的风格。百褶裙、针织背心、衬衫、玛丽珍鞋是学院风的标配，配色以米色、棕色、藏蓝色为主，整体给人一种乖巧又精致的感觉。',
      '第二种：法式田园风。今年韩系穿搭中融入了很多法式元素，碎花裙、泡泡袖上衣、草编包都是这一风格的代表单品。浅色系为主，搭配一些蕾丝或者荷叶边的细节，充满浪漫的少女气息。'
    ]
  },
  {
    slug: 'beginner-nail-art-tutorial',
    title: '少女美甲入门：在家也能做的5款可爱美甲',
    excerpt: '去美甲店太贵？自己在家也能做出可爱又精致的美甲！从基础工具到5款简单易学的少女美甲教程，手残党也能轻松上手~',
    category: '少女美妆',
    categorySlug: 'beauty',
    coverImage: 'https://readdy.ai/api/search-image?query=cute%20pastel%20color%20nail%20art%20with%20flowers%20and%20hearts%20design%20on%20young%20girl%20hands%2C%20nail%20polish%20bottles%20nearby%2C%20soft%20pink%20background%2C%20beauty%20photography%2C%20feminine%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=article-beauty-03&orientation=landscape',
    author: '蜜桃酱',
    authorAvatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20with%20peach%20color%20hair%2C%20kawaii%20illustration%2C%20simple%20background%2C%20clean%20design&width=100&height=100&seq=avatar-momo&orientation=squarish',
    publishDate: '2026-02-25',
    readTime: '6分钟',
    tags: ['美甲', '少女美甲', 'DIY', '美容'],
    featured: false,
    content: [
      '精致的少女怎么能少了美美的指甲呢？但是每个月去美甲店确实是一笔不小的开销。其实很多简单的美甲款式在家就能搞定，今天就手把手教大家几款超可爱的少女美甲~',
      '准备工具：底油、彩色指甲油（粉色、白色、薄荷绿是少女美甲的基础色）、亮油、美甲贴纸、点珠笔（可以用牙签代替）。这些基础工具加起来可能还不到去一次美甲店的价格哦。'
    ]
  }
];

export const recommendedItems: RecommendedItem[] = [
  {
    slug: 'item-1',
    name: '樱花限定腮红盘',
    description: '三色渐变腮红，粉嫩显色不飞粉，打造自然少女好气色',
    price: '¥128',
    image: 'https://readdy.ai/api/search-image?query=cute%20pink%20blush%20compact%20with%20cherry%20blossom%20design%20on%20white%20background%2C%20soft%20feminine%20product%20photography%2C%20clean%20minimal%20style%2C%20pastel%20aesthetic&width=400&height=400&seq=rec-item-01&orientation=squarish',
    category: '美妆',
    rating: 4.8
  },
  {
    slug: 'item-2',
    name: '少女碎花连衣裙',
    description: '法式复古碎花连衣裙，收腰显瘦，春日约会必备单品',
    price: '¥259',
    image: 'https://readdy.ai/api/search-image?query=cute%20floral%20print%20dress%20on%20wooden%20hanger%20against%20white%20wall%2C%20pastel%20pink%20and%20white%20flowers%20pattern%2C%20fashion%20product%20photography%2C%20soft%20lighting%2C%20feminine%20style&width=400&height=400&seq=rec-item-02&orientation=squarish',
    category: '穿搭',
    rating: 4.6
  },
  {
    slug: 'item-3',
    name: '梦幻星星灯串',
    description: '暖黄LED星星灯串，USB供电，打造梦幻少女房间氛围',
    price: '¥49',
    image: 'https://readdy.ai/api/search-image?query=warm%20fairy%20string%20lights%20on%20white%20background%2C%20star%20shaped%20LED%20lights%2C%20cozy%20atmosphere%20product%20photography%2C%20soft%20glow%2C%20minimal%20style&width=400&height=400&seq=rec-item-03&orientation=squarish',
    category: '家居',
    rating: 4.9
  },
  {
    slug: 'item-4',
    name: '猫咪爪润唇膏',
    description: '超萌猫咪爪造型润唇膏，蜜桃香味，滋润不黏腻',
    price: '¥35',
    image: 'https://readdy.ai/api/search-image?query=cute%20cat%20paw%20shaped%20lip%20balm%20on%20pink%20background%2C%20kawaii%20cosmetic%20product%20photography%2C%20soft%20pastel%20aesthetic%2C%20clean%20minimal%20style&width=400&height=400&seq=rec-item-04&orientation=squarish',
    category: '美妆',
    rating: 4.7
  },
  {
    slug: 'item-5',
    name: '手账本套装礼盒',
    description: '少女心手账入门套装，含本子、贴纸、胶带和彩色笔',
    price: '¥89',
    image: 'https://readdy.ai/api/search-image?query=cute%20stationery%20set%20with%20notebook%20and%20washi%20tapes%20and%20stickers%20on%20white%20background%2C%20pastel%20colors%2C%20product%20photography%2C%20kawaii%20style%2C%20clean%20composition&width=400&height=400&seq=rec-item-05&orientation=squarish',
    category: '文具',
    rating: 4.5
  },
  {
    slug: 'item-6',
    name: '蝴蝶结发饰套装',
    description: '六款不同色系蝴蝶结发夹套装，日常百搭不重样',
    price: '¥68',
    image: 'https://readdy.ai/api/search-image?query=cute%20pastel%20color%20ribbon%20bow%20hair%20clips%20set%20on%20white%20background%2C%20feminine%20accessory%20product%20photography%2C%20soft%20lighting%2C%20kawaii%20aesthetic&width=400&height=400&seq=rec-item-06&orientation=squarish',
    category: '配饰',
    rating: 4.8
  }
];